import { HttpBackend, HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AppSettings} from 'src/interfaces/appsettings.interface';
import { firstValueFrom } from 'rxjs';
import { API_BASE_URI } from 'src/shared/constants';

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {
  private appSettings: AppSettings | any;

  // use custom httpClient to avoid http interceptor
  private customHttpClient: HttpClient;

  constructor(backend: HttpBackend) {
    this.customHttpClient = new HttpClient(backend);
  }

  get settings(): AppSettings {
    return this.appSettings;
  }

  async load(): Promise<void> {
    this.appSettings = await firstValueFrom(
      this.customHttpClient.get<AppSettings>(
        API_BASE_URI + '/api/common/appsettings'
      )
    );
  }
}
